import { ActionTypes } from '../constants/actionTypes.js';
import { api } from "../apis/ComponentApis.js";
import { queryClient } from '../query/queryClient.js';
import * as action from './index.js';

export const fetchRowDetailsRequest = () => ({
    type: ActionTypes.FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_REQUEST,
});

export const fetchReleaseComponentDetailsData = (site_id, component_type_id, firmware_version, signal) => async (dispatch) => {
    dispatch(fetchRowDetailsRequest());
    try {
        const response = await api.get(`/api/GetReleaseComponentDetails?site_id=${site_id}&component_type_id=${component_type_id}&firmware_version=${firmware_version}`, { signal });
        dispatch({
            type: ActionTypes.FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_DATALIST,
            payload: { response: response.data }
        })
    } catch (error) {
         if (error?.name === 'CanceledError') {
            console.log('Request canceled', error);
            return;
        }
        dispatch({
            type: ActionTypes.FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_FAILURE,
            payload: error
        })
    }
};

export const resetReleaseDetailsData = () => ({
    type: ActionTypes.RESET_RELEASE_MANAGEMENT_COMPONENT_DETAILS_DATALIST,
})

export const approvalStatusSelection = (selectedStatus) => ({
    type: ActionTypes.SET_APPROVAL_STATUS,
    payload: selectedStatus
});

export const setRejectionReason = (reason) => ({
    type: ActionTypes.SET_REJECTION_REASON,
    payload: reason
});

export const setInformationAlert = (active) => ({
    type: ActionTypes.SET_INFORMATION_ALERT,
    payload: { active: active }
});

export const fetchReleaseNotesDownloadRequest = () => ({
    type: ActionTypes.FETCH_RELEASE_NOTES_DOWNLOAD_REQUEST,
});

export const setInformationAlertText = (text) => ({
    type: ActionTypes.SET_INFORMATION_ALERT_TEXT,
    payload: { text: text }
});

export const fetchNetworkDiagram = (site_id) => async (dispatch) => {
    try {
        const response = await api.get(`/api/GetNetworkdiagram?siteId=${site_id}`)
        if (response.status === 200) {
            const fileLink = response.data.value;
            try {
                const url = new URL(fileLink);
                const fileResponse = await fetch(url.toString());

                if (fileResponse.ok) {
                    dispatch({
                        type: ActionTypes.STATUS_TOASTMESSAGE,
                        payload: { open: true, message: "Download Initiated", status: "success" }
                    });
                } else {
                     dispatch({
                        type: ActionTypes.STATUS_TOASTMESSAGE,
                        payload: { open: true, message: "Failed to fetch the file", status: "error" }
                    });
                }
                const blob = await fileResponse.blob();
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = 'network-diagram.pdf';
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(downloadUrl);
            } catch (err) {
                console.error('Invalid or untrusted URL:', err);
                dispatch({
                    type: ActionTypes.STATUS_TOASTMESSAGE,
                    payload: { open: true, message: "Failed to fetch the Network Diagram", status: "error" }
                });
            }
        }
    } catch (error) {
        console.log(error);
    }
};

export const getsReleaseNotes = (releaseParams) => async (dispatch) => {
    const { file_name, component_type_id, firmware_version } = releaseParams;
    dispatch(action.fetchReleaseNotesDownloadRequest());
    try {
        const response = await api.get(`/api/ReleaseNoteDownload?filename=${file_name}&componentTypeId=${component_type_id}&firmwareVersion=${firmware_version}`,
            { skipInterceptor: true }
        );
        if (response.status === 200) {
            const fileLink = response.data.value;
            try {
                const fileResponse = await fetch(fileLink);
                const fileText = await fileResponse.text();
                dispatch(action.setInformationAlertText(fileText));
            } catch (error) {
                console.error('Error fetching the file:', error);
                dispatch({
                    type: ActionTypes.STATUS_TOASTMESSAGE,
                    payload: { open: true, message: "Failed to fetch Release Notes", status: "error" }
                });
                dispatch(action.setInformationAlertText(false));
            }
        }
    } catch (error) {
        console.log(error);
       dispatch(action.setInformationAlertText(false));
    }
};

export const setApprovedOrRejected = (releaseData, signal) => async (dispatch, getState) => {
    try {
        const response = await api.put(`/api/ApproveAndRejectRelease`, releaseData, { signal });
        if (response.status === 200) {
           await queryClient.invalidateQueries({ queryKey: ['mrt', 'ReleaseComponentManagement'], exact: false });
        }
        dispatch({
            type: ActionTypes.STATUS_TOASTMESSAGE,
            payload: { open: true, message: "The Release status has been updated successfully", status: "success" }
        });
    } catch (error) {
        if (error?.name === 'CanceledError') {
            console.log('Request canceled', error);
            return;
        }
        dispatch({
            type: ActionTypes.FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_FAILURE,
            payload: error
        });
        dispatch({
            type: ActionTypes.STATUS_TOASTMESSAGE,
            payload: { open: true, message: "Failed to update Release status", status: "error" }
        });
    }
};

